import { useSuspenseQuery } from "@tanstack/react-query";

import { authService } from "services/auth";
import { ReactQueryKeysGlobal } from "services/queryKeys";

export const fetchLoginId = async () => {
  return process.env.REACT_APP_LITE
    ? "firebolt-core-login-id"
    : await authService.getLoginId();
};

export const useLoginId = () => {
  const { data } = useSuspenseQuery({
    queryKey: [ReactQueryKeysGlobal.loginId],
    queryFn: fetchLoginId,
  });

  return {
    loginId: data,
  };
};
